module.exports = "/_next/static/images/18696b1ee2e134e96d2c994d037f86b5-rewards-app-xs@2x.png";